module.exports = __webpack_public_path__ + "img/bank-industry-problem-icon3.ca42eae2.png";